/* Component to display the deptPost data */
import React, { useEffect, useState } from "react"
import Card from "react-bootstrap/Card"
import styles from "../../styles/Post.module.css"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { Link, useHistory } from "react-router-dom"
import Avatar from "../../components/Avatar"
import { axiosInstance, axiosRes } from "../../api/axiosDefaults"
import { PostDropdown } from "../../components/PostDropdown"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import useHostName from "../../hooks/useHostName"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import toast from "react-hot-toast";
import { useSetImageContext } from '../../contexts/ImageContext';

const DeptPost = (props) => {
  const setImage = useSetImageContext();
  const [showActionMenu, setShowActionMenu] = useState(true);
  
  const {
    id,
    owner,
    name,
    profile_id,
    profile_image,
    departments,
    position,
    title,
    content,
    image1,
    image2,
    image3,
    image4,
    image5,
    updated_at,
    is_owner
  } = props

  const host = useHostName()
  const currentUser = useCurrentUser()
  const history = useHistory()

  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/department/posts/${id}/edit`
    )
  }

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosRes.delete(`/department/posts/${id}/`)
        toast.success(`Post Deleted`);
        history.goBack()
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/department/posts/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        history.goBack() 
        toast.success(`Post Deleted Successfully!`);
      }
    } catch (err) { }
  };

  useEffect(() => {
        if (
          currentUser &&
          currentUser?.groups.length > 0 &&
          (currentUser?.groups[0]?.name === "Admincreative" ||
            currentUser?.groups[0]?.name === "Crew")
        ) {
          // now check where the post is His own post or NOT
          if (Number(profile_id) !== Number(currentUser?.profile_id)) {
            setShowActionMenu(false);
          }
        } else {
          if (
            currentUser &&
            currentUser?.groups.length > 0 &&
            currentUser?.groups[0]?.name === "Cast"
          ) {
            // Never show the menu
            setShowActionMenu(false);
          }
        }
      }, [profile_id, currentUser]); 

  const handleClickFull1 = () => {
    setImage(image1); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

  const handleClickFull2 = () => {
    setImage(image2); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

  const handleClickFull3 = () => {
    setImage(image3); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

  const handleClickFull4 = () => {
    setImage(image4); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

  const handleClickFull5 = () => {
    setImage(image5); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);  
  };

  const [isImage1, setIsImage1] = useState(false);
  const [isImage2, setIsImage2] = useState(false);
  const [isImage3, setIsImage3] = useState(false);
  const [isImage4, setIsImage4] = useState(false);
  const [isImage5, setIsImage5] = useState(false);

  const getContentTypeWithGET = async (url) => {
    const res = await fetch(url, { method: 'GET', cache: 'no-store' });
    return res.headers.get('Content-Type');
  };

  const isImageFile = (fileType) => {
    const acceptedImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/tiff",
      "image/svg+xml",
    ];
    return acceptedImageTypes.includes(fileType);
  };

  useEffect(() => {
    const dataURLs = [image1, image2, image3, image4, image5];
    const stateSetters = [setIsImage1, setIsImage2, setIsImage3, setIsImage4, setIsImage5];

    dataURLs?.forEach((url, index) => {
      const setState = stateSetters[index];
      if (url) {
        getContentTypeWithGET(url)
          .then((type) => {
            const isImage = isImageFile(type);
            setState(isImage);
          })
          .catch((err) => {
            setState(false);
          });
      } else {
        setState(false);
      }
    });
  }, [image1, image2, image3, image4, image5]);

  return (
    <div>
      <Card >
      <Card.Body className={`py-0 px-0 ${styles.PostTop}`}>
          <Row className={`d-flex align-items-center my-0 py-0 py-sm-1`}>
          <Col xs={12} sm={3} className="my-0" >
          {/* small */}
          <div className='d-none d-sm-block'>
          <Row className='pt-1'>
          {/* theirs */}
          <Col xs={3} className="pl-3 pr-0">
          <Link
            to={`/${localStorage.getItem(
              "projectSlug"
            )}/profiles/${profile_id}`}
          >
            <Avatar src={profile_image} height={45} />
          </Link>
          </Col>

          <Col xs={9} className="pl-2 pr-0" >
          <div className={`${styles.Content4} pl-2 ml-3`}>
          <p className={`${styles.WhiteName}`}>{name}
          </p>
          <p className={`${styles.Posit}`}>{position}
          </p>
          </div>
          <div>
          </div>
          </Col>
          </Row>   
          </div>     
          {/* mobile */}
          <div className='d-sm-none'>
          <Row className='pb-0 mb-0'>
          <Col className="d-flex align-items-center" xs={2}>
            <Link
              to={`/${localStorage.getItem(
                "projectSlug"
              )}/profiles/${profile_id}`}
            >
              <Avatar src={profile_image} height={40} />
            </Link>
          </Col>

          <Col xs={8} className="text-center mb-0 pb-0" >
          <p className={`${styles.WhiteName}`}>{name}
          </p>
          <p className={`${styles.Posit}`}>{position}
          </p>
          <Row className={`${styles.Content3} my-0 mr-1 ml-1`}>
          <Col className='px-0 mx-0 text-center' xs={6}>
            {departments && <p style={{ textTransform: 'capitalize'}}>
              {departments}</p>}
          </Col>
           <Col className='px-0 mx-0 text-center' xs={6}>
            <p className={ `${styles.Date}`}> {updated_at}</p>
          </Col>
          </Row>
          </Col>
          <Col xs={2}>
          <div className={`${styles.Icon}`} >
            {showActionMenu && (
            <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />
            ) } 
          </div>
          </Col>
          </Row>
          </div> 
          </Col>    
          <Col xs={12} sm={6} className="my-0 d-none d-sm-block" >
            <Row className={`${styles.Content3} pt-0 my-0 mr-1 ml-1`}>
                <Col className='px-0 mx-0 py-0 text-center' xs={12}>
                  {departments && <p 
                  style={{ textTransform: 'uppercase', fontWeight: '700'}}>
                    {departments}</p>}
                </Col>
            </Row>
          </Col> 
          {/* edit and date small */}
          <Col xs={12} sm={3} className="my-0 " >
            <div className='d-none d-sm-block'>
            <Row className='d-flex align-items-center' >
            <Col className="pl-0 pr-0" sm={9} >
            <p className={ `text-center  ${styles.Date}`}>{updated_at}
            </p>
            </Col>
            <Col sm={3}
            className="d-flex align-items-center px-0" >
            <div className={`${styles.Icon}`} >
            {showActionMenu && (
            <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />
            ) } 
            </div>
            </Col>
            </Row>   
            </div>     
            </Col>                
          </Row>
      </Card.Body>
      <Card.Body className="pt-2 px-md-5" >
            {title && <h5 style={{ fontStyle: 'italic' }}
              className="text-center">{title}</h5>}
            <hr className={`mt-2 mb-0`} />
            {content && <Card.Text className={`${styles.Role}`}>{content}</Card.Text>}
      </Card.Body>
      <hr />
      {image1 || image2 || image3 || image4 || image5 ? (
              <h5 className={`text-center py-0 mx-5 my-3 ${styles.SubTitle }`}
              >IMAGES</h5>
      ) : ("") }
      <div className='px-0'>
      {/* image 1/2  */}
      <Row className='mt-3 mb-0'>
      {image1 && (
        <Col xs={12} md={6} className={`text-center px-0 mx-0 mb-5`}>
          <Card className="shadow-sm h-100 mx-3 mx-md-5">
          <Card.Body className={`text-center px-md-5 `}  >
            {isImage1 ? (
              <figure className="m-0 p-0 text-center">
                <Card.Img
                  src={image1}
                  alt={`image1`}
                  className={styles.ImagesIndex}
                />
              </figure>
            ) : (
              <iframe
                src={image1}
                allow="fullscreen"
                title="depimage1"
                iframeClassName={styles.iframe}
              />
            )}
            </Card.Body>
            <Card.Body>
              <p className={`${styles.BoldScene}`}>
                IMAGE 1</p>
              <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                onClick={() => handleClickFull1() }>FULLSIZE</p> 
            </Card.Body>
          </Card>
        </Col>
      )}
      {image2 && (
        <Col xs={12} md={6} className={`text-center px-0 mx-0 mb-5`}>
          <Card className="shadow-sm h-100 mx-3 mx-md-5">
          <Card.Body className={`text-center px-md-5 `}  >
            {isImage2 ? (
              <figure className="m-0 p-0 text-center">
                <Card.Img
                  src={image2}
                  alt={`image2`}
                  className={styles.ImagesIndex}
                />
              </figure>
            ) : (
              <iframe
                src={image2}
                title="depimage2"
                allow="fullscreen"
                  iframeClassName={styles.iframe}
              />
            )}
            </Card.Body>
            <Card.Body>
              <p className={`${styles.BoldScene}`}>
                IMAGE 2</p>
              <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                onClick={() => handleClickFull2() }>FULLSIZE</p> 
            </Card.Body>
          </Card>
        </Col>
      )}                          
      </Row>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`${styles.BreakIm} mt-0 mb-3 d-none d-md-block`}/>
      </Col>
      </Row>
      {/* image 3/4  */}
      <Row className='mb-0'>
      {image3 && (
        <Col xs={12} md={6} className={`text-center px-0 mx-0 mb-5`}>
          <Card className="shadow-sm h-100 mx-3 mx-md-5">
          <Card.Body className={`text-center px-md-5 `}  >
            {isImage3 ? (
              <figure className="m-0 p-0 text-center">
                <Card.Img
                  src={image3}
                  alt={`image3`}
                  className={styles.ImagesIndex}
                />
              </figure>
            ) : (
              <iframe
                src={image3}
                title="depimage3"
                allow="fullscreen"
                  iframeClassName={styles.iframe}
              />
            )}
            </Card.Body>
            <Card.Body>
              <p className={`${styles.BoldScene}`}>
                IMAGE 3</p>
              <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                onClick={() => handleClickFull3() }>FULLSIZE</p> 
            </Card.Body>
          </Card>
        </Col>
      )}
      {image4 && (
        <Col xs={12} md={6} className={`text-center px-0 mx-0 mb-5`}>
          <Card className="shadow-sm h-100 mx-3 mx-md-5">
          <Card.Body className={`text-center px-md-5 `}  >
            {isImage4 ? (
              <figure className="m-0 p-0 text-center">
                <Card.Img
                  src={image4}
                  alt={`image4`}
                  className={styles.ImagesIndex}
                />
              </figure>
            ) : (
              <iframe
                src={image4}
                title="depimage4"
                allow="fullscreen"
                  iframeClassName={styles.iframe}
              />
            )}
            </Card.Body>
            <Card.Body>
              <p className={`${styles.BoldScene}`}>
                IMAGE 4</p>
              <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                onClick={() => handleClickFull4() }>FULLSIZE</p> 
            </Card.Body>
          </Card>
        </Col>
      )}                          
      </Row>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`${styles.BreakIm} mt-0 mb-3 d-none d-md-block`}/>
      </Col>
      </Row>
      {/* image 5  */}
      <Row className='mb-0'>
      {image5 && (<>
          <Col className='d-none d-md-block' md={3} ></Col>
          <Col className={`text-center px-0 mx-0 mb-5`} xs={12} md={6}>
          <Card className="shadow-sm h-100 mx-3 mx-md-5">
          <Card.Body className={`text-center px-md-5 `}  >
            {isImage5 ? (
              <figure className="m-0 p-0 text-center">
                <Card.Img
                  src={image5}
                  alt={`image5`}
                  className={styles.ImagesIndex}
                />
              </figure>
            ) : (
              <iframe
                src={image5}
                title="depimage5"
                allow="fullscreen"
                  iframeClassName={styles.iframe}
              />
            )}
            </Card.Body>
            <Card.Body>
              <p className={`${styles.BoldScene}`}>
                IMAGE 1</p>
              <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                onClick={() => handleClickFull5() }>FULLSIZE</p> 
            </Card.Body>
          </Card>
        </Col>
        </>
      )}
      </Row>
      </div>

        {/* <Row>
          {[image1, image2, image3, image4, image5].map((img, index) => {
            const isImage = [isImage1, isImage2, isImage3, isImage4, isImage5][index];
            const previewTitle = `file-preview-${index + 1}`;

            return (
              img && (
                <Col xs={12} md={6} key={index} className={`text-center px-0 mx-0 mb-5`}>
                  <Card className="shadow-sm h-100 mx-3 mx-md-5">
                  <Card.Body className={`text-center px-md-5 `}  >
                    <p className={`${styles.BoldScene} mb-2`}>
                        IMAGE 1</p>
                    {isImage ? (
                      <figure className="m-0 p-0 text-center">
                        <Card.Img
                          src={img}
                          alt={`image${index + 1}`}
                          className={styles.ImagesLand}
                          style={{
                            maxHeight: "300px",
                            objectFit: "contain",
                            borderRadius: "8px",
                          }}
                        />
                      </figure>
                    ) : (
                      <iframe
                        title={previewTitle}
                        src={img}
                        width="100%"
                        height="300px"
                        style={{
                          border: "none",
                          borderRadius: "8px",
                          padding: "1rem",
                        }}
                      />
                    )}
                    </Card.Body>
                    <Card.Body>
                      <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                        onClick={() => handleClickFull1() }>FULLSIZE</p> 
                    </Card.Body>
                  </Card>
                </Col>
              )
            );
          })}
        </Row> */}
      </Card>
    </div>
  )
}

export default DeptPost
